import { Document } from "../newsdoc/newsdoc.mjs";
import { ServiceType, stackIntercept } from "@protobuf-ts/runtime-rpc";
import { MessageType, UnknownFieldHandler, WireType, reflectionMergePartial } from "@protobuf-ts/runtime";
//#region src/index/service.ts
/**
* @generated from protobuf enum elephant.index.EnabledFilter
*/
let EnabledFilter = /* @__PURE__ */ function(EnabledFilter) {
	/**
	* @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
	*/
	EnabledFilter[EnabledFilter["STATUS_UNSPECIFIED"] = 0] = "STATUS_UNSPECIFIED";
	/**
	* STATUS_ENABLED means that documents are currently being indexed to the
	* index set.
	*
	* @generated from protobuf enum value: STATUS_ENABLED = 1;
	*/
	EnabledFilter[EnabledFilter["STATUS_ENABLED"] = 1] = "STATUS_ENABLED";
	/**
	* STATUS_DISABLED means that no documents are being indexed to the index set.
	*
	* @generated from protobuf enum value: STATUS_DISABLED = 3;
	*/
	EnabledFilter[EnabledFilter["STATUS_DISABLED"] = 3] = "STATUS_DISABLED";
	return EnabledFilter;
}({});
var RegisterClusterRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.RegisterClusterRequest", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "endpoint",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "auth",
				kind: "message",
				T: () => RegisterClusterAuth
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.endpoint = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.endpoint = reader.string();
					break;
				case 3:
					message.auth = RegisterClusterAuth.internalBinaryRead(reader, reader.uint32(), options, message.auth);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.endpoint !== "") writer.tag(2, WireType.LengthDelimited).string(message.endpoint);
		if (message.auth) RegisterClusterAuth.internalBinaryWrite(message.auth, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.RegisterClusterRequest
*/
const RegisterClusterRequest = new RegisterClusterRequest$Type();
var RegisterClusterAuth$Type = class extends MessageType {
	constructor() {
		super("elephant.index.RegisterClusterAuth", [
			{
				no: 1,
				name: "iam",
				kind: "scalar",
				T: 8
			},
			{
				no: 2,
				name: "username",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "password",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "insecure_tls",
				kind: "scalar",
				T: 8
			},
			{
				no: 5,
				name: "ca_cert",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.iam = false;
		message.username = "";
		message.password = "";
		message.insecureTls = false;
		message.caCert = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.iam = reader.bool();
					break;
				case 2:
					message.username = reader.string();
					break;
				case 3:
					message.password = reader.string();
					break;
				case 4:
					message.insecureTls = reader.bool();
					break;
				case 5:
					message.caCert = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.iam !== false) writer.tag(1, WireType.Varint).bool(message.iam);
		if (message.username !== "") writer.tag(2, WireType.LengthDelimited).string(message.username);
		if (message.password !== "") writer.tag(3, WireType.LengthDelimited).string(message.password);
		if (message.insecureTls !== false) writer.tag(4, WireType.Varint).bool(message.insecureTls);
		if (message.caCert !== "") writer.tag(5, WireType.LengthDelimited).string(message.caCert);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.RegisterClusterAuth
*/
const RegisterClusterAuth = new RegisterClusterAuth$Type();
var RegisterClusterResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.RegisterClusterResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.RegisterClusterResponse
*/
const RegisterClusterResponse = new RegisterClusterResponse$Type();
var ReindexRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ReindexRequest", [{
			no: 1,
			name: "cluster",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.cluster = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.cluster = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.cluster !== "") writer.tag(1, WireType.LengthDelimited).string(message.cluster);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ReindexRequest
*/
const ReindexRequest = new ReindexRequest$Type();
var ReindexResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ReindexResponse", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ReindexResponse
*/
const ReindexResponse = new ReindexResponse$Type();
var ListClustersRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ListClustersRequest", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ListClustersRequest
*/
const ListClustersRequest = new ListClustersRequest$Type();
var ListClustersResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ListClustersResponse", [{
			no: 1,
			name: "clusters",
			kind: "message",
			repeat: 2,
			T: () => Cluster
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.clusters = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.clusters.push(Cluster.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.clusters.length; i++) Cluster.internalBinaryWrite(message.clusters[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ListClustersResponse
*/
const ListClustersResponse = new ListClustersResponse$Type();
var Cluster$Type = class extends MessageType {
	constructor() {
		super("elephant.index.Cluster", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "endpoint",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "index_set_count",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "auth",
				kind: "message",
				T: () => ClusterAuth
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.endpoint = "";
		message.indexSetCount = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.endpoint = reader.string();
					break;
				case 3:
					message.indexSetCount = reader.int64().toBigInt();
					break;
				case 4:
					message.auth = ClusterAuth.internalBinaryRead(reader, reader.uint32(), options, message.auth);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.endpoint !== "") writer.tag(2, WireType.LengthDelimited).string(message.endpoint);
		if (message.indexSetCount !== 0n) writer.tag(3, WireType.Varint).int64(message.indexSetCount);
		if (message.auth) ClusterAuth.internalBinaryWrite(message.auth, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.Cluster
*/
const Cluster = new Cluster$Type();
var ClusterAuth$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ClusterAuth", [{
			no: 1,
			name: "iam",
			kind: "scalar",
			T: 8
		}, {
			no: 2,
			name: "username",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.iam = false;
		message.username = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.iam = reader.bool();
					break;
				case 2:
					message.username = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.iam !== false) writer.tag(1, WireType.Varint).bool(message.iam);
		if (message.username !== "") writer.tag(2, WireType.LengthDelimited).string(message.username);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ClusterAuth
*/
const ClusterAuth = new ClusterAuth$Type();
var DeleteClusterRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.DeleteClusterRequest", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.DeleteClusterRequest
*/
const DeleteClusterRequest = new DeleteClusterRequest$Type();
var DeleteClusterResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.DeleteClusterResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.DeleteClusterResponse
*/
const DeleteClusterResponse = new DeleteClusterResponse$Type();
var DeleteIndexSetRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.DeleteIndexSetRequest", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.DeleteIndexSetRequest
*/
const DeleteIndexSetRequest = new DeleteIndexSetRequest$Type();
var DeleteIndexSetResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.DeleteIndexSetResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.DeleteIndexSetResponse
*/
const DeleteIndexSetResponse = new DeleteIndexSetResponse$Type();
var SetIndexSetStatusRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.SetIndexSetStatusRequest", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "active",
				kind: "scalar",
				T: 8
			},
			{
				no: 3,
				name: "force_active",
				kind: "scalar",
				T: 8
			},
			{
				no: 4,
				name: "enabled",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.active = false;
		message.forceActive = false;
		message.enabled = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.active = reader.bool();
					break;
				case 3:
					message.forceActive = reader.bool();
					break;
				case 4:
					message.enabled = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.active !== false) writer.tag(2, WireType.Varint).bool(message.active);
		if (message.forceActive !== false) writer.tag(3, WireType.Varint).bool(message.forceActive);
		if (message.enabled !== false) writer.tag(4, WireType.Varint).bool(message.enabled);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.SetIndexSetStatusRequest
*/
const SetIndexSetStatusRequest = new SetIndexSetStatusRequest$Type();
var SetIndexSetStatusResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.SetIndexSetStatusResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.SetIndexSetStatusResponse
*/
const SetIndexSetStatusResponse = new SetIndexSetStatusResponse$Type();
var PartialReindexRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.PartialReindexRequest", [{
			no: 1,
			name: "index_set",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "position",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.indexSet = "";
		message.position = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.indexSet = reader.string();
					break;
				case 2:
					message.position = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.indexSet !== "") writer.tag(1, WireType.LengthDelimited).string(message.indexSet);
		if (message.position !== 0n) writer.tag(2, WireType.Varint).int64(message.position);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.PartialReindexRequest
*/
const PartialReindexRequest = new PartialReindexRequest$Type();
var PartialReindexResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.PartialReindexResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.PartialReindexResponse
*/
const PartialReindexResponse = new PartialReindexResponse$Type();
var ListIndexSetsRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ListIndexSetsRequest", [
			{
				no: 1,
				name: "cluster",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "only_active",
				kind: "scalar",
				T: 8
			},
			{
				no: 3,
				name: "status",
				kind: "enum",
				T: () => ["elephant.index.EnabledFilter", EnabledFilter]
			},
			{
				no: 4,
				name: "cursor",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.cluster = "";
		message.onlyActive = false;
		message.status = 0;
		message.cursor = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.cluster = reader.string();
					break;
				case 2:
					message.onlyActive = reader.bool();
					break;
				case 3:
					message.status = reader.int32();
					break;
				case 4:
					message.cursor = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.cluster !== "") writer.tag(1, WireType.LengthDelimited).string(message.cluster);
		if (message.onlyActive !== false) writer.tag(2, WireType.Varint).bool(message.onlyActive);
		if (message.status !== 0) writer.tag(3, WireType.Varint).int32(message.status);
		if (message.cursor !== "") writer.tag(4, WireType.LengthDelimited).string(message.cursor);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ListIndexSetsRequest
*/
const ListIndexSetsRequest = new ListIndexSetsRequest$Type();
var ListIndexSetsResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ListIndexSetsResponse", [{
			no: 1,
			name: "index_sets",
			kind: "message",
			repeat: 2,
			T: () => IndexSet
		}, {
			no: 2,
			name: "next_page",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.indexSets = [];
		message.nextPage = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.indexSets.push(IndexSet.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.nextPage = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.indexSets.length; i++) IndexSet.internalBinaryWrite(message.indexSets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.nextPage !== "") writer.tag(2, WireType.LengthDelimited).string(message.nextPage);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ListIndexSetsResponse
*/
const ListIndexSetsResponse = new ListIndexSetsResponse$Type();
var IndexSet$Type = class extends MessageType {
	constructor() {
		super("elephant.index.IndexSet", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "cluster",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "enabled",
				kind: "scalar",
				T: 8
			},
			{
				no: 4,
				name: "active",
				kind: "scalar",
				T: 8
			},
			{
				no: 5,
				name: "position",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.cluster = "";
		message.enabled = false;
		message.active = false;
		message.position = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.cluster = reader.string();
					break;
				case 3:
					message.enabled = reader.bool();
					break;
				case 4:
					message.active = reader.bool();
					break;
				case 5:
					message.position = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.cluster !== "") writer.tag(2, WireType.LengthDelimited).string(message.cluster);
		if (message.enabled !== false) writer.tag(3, WireType.Varint).bool(message.enabled);
		if (message.active !== false) writer.tag(4, WireType.Varint).bool(message.active);
		if (message.position !== 0n) writer.tag(5, WireType.Varint).int64(message.position);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.IndexSet
*/
const IndexSet = new IndexSet$Type();
var MultiSearchRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MultiSearchRequest", [{
			no: 1,
			name: "queries",
			kind: "message",
			repeat: 2,
			T: () => QueryRequestV1
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.queries = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.queries.push(QueryRequestV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.queries.length; i++) QueryRequestV1.internalBinaryWrite(message.queries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MultiSearchRequest
*/
const MultiSearchRequest = new MultiSearchRequest$Type();
var MultiSearchResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MultiSearchResponse", [{
			no: 1,
			name: "results",
			kind: "message",
			repeat: 2,
			T: () => QueryResponseV1
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.results = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.results.push(QueryResponseV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.results.length; i++) QueryResponseV1.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MultiSearchResponse
*/
const MultiSearchResponse = new MultiSearchResponse$Type();
var QueryRequestV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.QueryRequestV1", [
			{
				no: 1,
				name: "document_type",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "language",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "query",
				kind: "message",
				T: () => QueryV1
			},
			{
				no: 4,
				name: "fields",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 5,
				name: "sort",
				kind: "message",
				repeat: 2,
				T: () => SortingV1
			},
			{
				no: 6,
				name: "source",
				kind: "scalar",
				T: 8
			},
			{
				no: 7,
				name: "from",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 8,
				name: "size",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 9,
				name: "search_after",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 10,
				name: "load_document",
				kind: "scalar",
				T: 8
			},
			{
				no: 11,
				name: "subscribe",
				kind: "scalar",
				T: 8
			},
			{
				no: 12,
				name: "shared",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.documentType = "";
		message.language = "";
		message.fields = [];
		message.sort = [];
		message.source = false;
		message.from = 0n;
		message.size = 0n;
		message.searchAfter = [];
		message.loadDocument = false;
		message.subscribe = false;
		message.shared = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.documentType = reader.string();
					break;
				case 2:
					message.language = reader.string();
					break;
				case 3:
					message.query = QueryV1.internalBinaryRead(reader, reader.uint32(), options, message.query);
					break;
				case 4:
					message.fields.push(reader.string());
					break;
				case 5:
					message.sort.push(SortingV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 6:
					message.source = reader.bool();
					break;
				case 7:
					message.from = reader.int64().toBigInt();
					break;
				case 8:
					message.size = reader.int64().toBigInt();
					break;
				case 9:
					message.searchAfter.push(reader.string());
					break;
				case 10:
					message.loadDocument = reader.bool();
					break;
				case 11:
					message.subscribe = reader.bool();
					break;
				case 12:
					message.shared = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.documentType !== "") writer.tag(1, WireType.LengthDelimited).string(message.documentType);
		if (message.language !== "") writer.tag(2, WireType.LengthDelimited).string(message.language);
		if (message.query) QueryV1.internalBinaryWrite(message.query, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.fields.length; i++) writer.tag(4, WireType.LengthDelimited).string(message.fields[i]);
		for (let i = 0; i < message.sort.length; i++) SortingV1.internalBinaryWrite(message.sort[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		if (message.source !== false) writer.tag(6, WireType.Varint).bool(message.source);
		if (message.from !== 0n) writer.tag(7, WireType.Varint).int64(message.from);
		if (message.size !== 0n) writer.tag(8, WireType.Varint).int64(message.size);
		for (let i = 0; i < message.searchAfter.length; i++) writer.tag(9, WireType.LengthDelimited).string(message.searchAfter[i]);
		if (message.loadDocument !== false) writer.tag(10, WireType.Varint).bool(message.loadDocument);
		if (message.subscribe !== false) writer.tag(11, WireType.Varint).bool(message.subscribe);
		if (message.shared !== false) writer.tag(12, WireType.Varint).bool(message.shared);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.QueryRequestV1
*/
const QueryRequestV1 = new QueryRequestV1$Type();
var QueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.QueryV1", [
			{
				no: 1,
				name: "bool",
				kind: "message",
				oneof: "conditions",
				T: () => BoolQueryV1
			},
			{
				no: 2,
				name: "range",
				kind: "message",
				oneof: "conditions",
				T: () => RangeQueryV1
			},
			{
				no: 3,
				name: "exists",
				kind: "scalar",
				oneof: "conditions",
				T: 9
			},
			{
				no: 4,
				name: "match_all",
				kind: "message",
				oneof: "conditions",
				T: () => MatchAllQueryV1
			},
			{
				no: 5,
				name: "term",
				kind: "message",
				oneof: "conditions",
				T: () => TermQueryV1
			},
			{
				no: 6,
				name: "terms",
				kind: "message",
				oneof: "conditions",
				T: () => TermsQueryV1
			},
			{
				no: 7,
				name: "match",
				kind: "message",
				oneof: "conditions",
				T: () => MatchQueryV1
			},
			{
				no: 8,
				name: "match_phrase",
				kind: "message",
				oneof: "conditions",
				T: () => MatchPhraseQueryV1
			},
			{
				no: 9,
				name: "query_string",
				kind: "scalar",
				oneof: "conditions",
				T: 9
			},
			{
				no: 10,
				name: "prefix",
				kind: "message",
				oneof: "conditions",
				T: () => PrefixQueryV1
			},
			{
				no: 11,
				name: "multi_match",
				kind: "message",
				oneof: "conditions",
				T: () => MultiMatchQueryV1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.conditions = { oneofKind: void 0 };
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.conditions = {
						oneofKind: "bool",
						bool: BoolQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.bool)
					};
					break;
				case 2:
					message.conditions = {
						oneofKind: "range",
						range: RangeQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.range)
					};
					break;
				case 3:
					message.conditions = {
						oneofKind: "exists",
						exists: reader.string()
					};
					break;
				case 4:
					message.conditions = {
						oneofKind: "matchAll",
						matchAll: MatchAllQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.matchAll)
					};
					break;
				case 5:
					message.conditions = {
						oneofKind: "term",
						term: TermQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.term)
					};
					break;
				case 6:
					message.conditions = {
						oneofKind: "terms",
						terms: TermsQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.terms)
					};
					break;
				case 7:
					message.conditions = {
						oneofKind: "match",
						match: MatchQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.match)
					};
					break;
				case 8:
					message.conditions = {
						oneofKind: "matchPhrase",
						matchPhrase: MatchPhraseQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.matchPhrase)
					};
					break;
				case 9:
					message.conditions = {
						oneofKind: "queryString",
						queryString: reader.string()
					};
					break;
				case 10:
					message.conditions = {
						oneofKind: "prefix",
						prefix: PrefixQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.prefix)
					};
					break;
				case 11:
					message.conditions = {
						oneofKind: "multiMatch",
						multiMatch: MultiMatchQueryV1.internalBinaryRead(reader, reader.uint32(), options, message.conditions.multiMatch)
					};
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.conditions.oneofKind === "bool") BoolQueryV1.internalBinaryWrite(message.conditions.bool, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "range") RangeQueryV1.internalBinaryWrite(message.conditions.range, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "exists") writer.tag(3, WireType.LengthDelimited).string(message.conditions.exists);
		if (message.conditions.oneofKind === "matchAll") MatchAllQueryV1.internalBinaryWrite(message.conditions.matchAll, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "term") TermQueryV1.internalBinaryWrite(message.conditions.term, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "terms") TermsQueryV1.internalBinaryWrite(message.conditions.terms, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "match") MatchQueryV1.internalBinaryWrite(message.conditions.match, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "matchPhrase") MatchPhraseQueryV1.internalBinaryWrite(message.conditions.matchPhrase, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "queryString") writer.tag(9, WireType.LengthDelimited).string(message.conditions.queryString);
		if (message.conditions.oneofKind === "prefix") PrefixQueryV1.internalBinaryWrite(message.conditions.prefix, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
		if (message.conditions.oneofKind === "multiMatch") MultiMatchQueryV1.internalBinaryWrite(message.conditions.multiMatch, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.QueryV1
*/
const QueryV1 = new QueryV1$Type();
var BoolQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.BoolQueryV1", [
			{
				no: 1,
				name: "must",
				kind: "message",
				repeat: 2,
				T: () => QueryV1
			},
			{
				no: 2,
				name: "must_not",
				kind: "message",
				repeat: 2,
				T: () => QueryV1
			},
			{
				no: 3,
				name: "should",
				kind: "message",
				repeat: 2,
				T: () => QueryV1
			},
			{
				no: 4,
				name: "filter",
				kind: "message",
				repeat: 2,
				T: () => QueryV1
			},
			{
				no: 5,
				name: "minimum_should_match",
				kind: "scalar",
				T: 3,
				L: 0
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.must = [];
		message.mustNot = [];
		message.should = [];
		message.filter = [];
		message.minimumShouldMatch = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.must.push(QueryV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.mustNot.push(QueryV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 3:
					message.should.push(QueryV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 4:
					message.filter.push(QueryV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 5:
					message.minimumShouldMatch = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.must.length; i++) QueryV1.internalBinaryWrite(message.must[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.mustNot.length; i++) QueryV1.internalBinaryWrite(message.mustNot[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.should.length; i++) QueryV1.internalBinaryWrite(message.should[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.filter.length; i++) QueryV1.internalBinaryWrite(message.filter[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.minimumShouldMatch !== 0n) writer.tag(5, WireType.Varint).int64(message.minimumShouldMatch);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.BoolQueryV1
*/
const BoolQueryV1 = new BoolQueryV1$Type();
var RangeQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.RangeQueryV1", [
			{
				no: 1,
				name: "field",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "gt",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "gte",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "lt",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "lte",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.gt = "";
		message.gte = "";
		message.lt = "";
		message.lte = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.gt = reader.string();
					break;
				case 3:
					message.gte = reader.string();
					break;
				case 4:
					message.lt = reader.string();
					break;
				case 5:
					message.lte = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		if (message.gt !== "") writer.tag(2, WireType.LengthDelimited).string(message.gt);
		if (message.gte !== "") writer.tag(3, WireType.LengthDelimited).string(message.gte);
		if (message.lt !== "") writer.tag(4, WireType.LengthDelimited).string(message.lt);
		if (message.lte !== "") writer.tag(5, WireType.LengthDelimited).string(message.lte);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.RangeQueryV1
*/
const RangeQueryV1 = new RangeQueryV1$Type();
var MatchAllQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MatchAllQueryV1", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MatchAllQueryV1
*/
const MatchAllQueryV1 = new MatchAllQueryV1$Type();
var TermQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.TermQueryV1", [
			{
				no: 1,
				name: "field",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "value",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "boost",
				kind: "scalar",
				T: 1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.value = "";
		message.boost = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.value = reader.string();
					break;
				case 3:
					message.boost = reader.double();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		if (message.value !== "") writer.tag(2, WireType.LengthDelimited).string(message.value);
		if (message.boost !== 0) writer.tag(3, WireType.Bit64).double(message.boost);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.TermQueryV1
*/
const TermQueryV1 = new TermQueryV1$Type();
var TermsQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.TermsQueryV1", [
			{
				no: 1,
				name: "field",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "values",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 3,
				name: "boost",
				kind: "scalar",
				T: 1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.values = [];
		message.boost = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.values.push(reader.string());
					break;
				case 3:
					message.boost = reader.double();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		for (let i = 0; i < message.values.length; i++) writer.tag(2, WireType.LengthDelimited).string(message.values[i]);
		if (message.boost !== 0) writer.tag(3, WireType.Bit64).double(message.boost);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.TermsQueryV1
*/
const TermsQueryV1 = new TermsQueryV1$Type();
var MatchQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MatchQueryV1", [
			{
				no: 1,
				name: "field",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "value",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "boost",
				kind: "scalar",
				T: 1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.value = "";
		message.boost = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.value = reader.string();
					break;
				case 3:
					message.boost = reader.double();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		if (message.value !== "") writer.tag(2, WireType.LengthDelimited).string(message.value);
		if (message.boost !== 0) writer.tag(3, WireType.Bit64).double(message.boost);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MatchQueryV1
*/
const MatchQueryV1 = new MatchQueryV1$Type();
var MultiMatchQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MultiMatchQueryV1", [
			{
				no: 1,
				name: "fields",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "query",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "boost",
				kind: "scalar",
				T: 1
			},
			{
				no: 5,
				name: "boolean_and",
				kind: "scalar",
				T: 8
			},
			{
				no: 6,
				name: "minimum_should_match",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "tie_breaker",
				kind: "scalar",
				T: 2
			},
			{
				no: 8,
				name: "prefix_length",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 9,
				name: "fuzziness",
				kind: "message",
				T: () => Fuzziness
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.fields = [];
		message.type = "";
		message.query = "";
		message.boost = 0;
		message.booleanAnd = false;
		message.minimumShouldMatch = "";
		message.tieBreaker = 0;
		message.prefixLength = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.fields.push(reader.string());
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.query = reader.string();
					break;
				case 4:
					message.boost = reader.double();
					break;
				case 5:
					message.booleanAnd = reader.bool();
					break;
				case 6:
					message.minimumShouldMatch = reader.string();
					break;
				case 7:
					message.tieBreaker = reader.float();
					break;
				case 8:
					message.prefixLength = reader.int64().toBigInt();
					break;
				case 9:
					message.fuzziness = Fuzziness.internalBinaryRead(reader, reader.uint32(), options, message.fuzziness);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.fields.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.fields[i]);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.query !== "") writer.tag(3, WireType.LengthDelimited).string(message.query);
		if (message.boost !== 0) writer.tag(4, WireType.Bit64).double(message.boost);
		if (message.booleanAnd !== false) writer.tag(5, WireType.Varint).bool(message.booleanAnd);
		if (message.minimumShouldMatch !== "") writer.tag(6, WireType.LengthDelimited).string(message.minimumShouldMatch);
		if (message.tieBreaker !== 0) writer.tag(7, WireType.Bit32).float(message.tieBreaker);
		if (message.prefixLength !== 0n) writer.tag(8, WireType.Varint).int64(message.prefixLength);
		if (message.fuzziness) Fuzziness.internalBinaryWrite(message.fuzziness, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MultiMatchQueryV1
*/
const MultiMatchQueryV1 = new MultiMatchQueryV1$Type();
var Fuzziness$Type = class extends MessageType {
	constructor() {
		super("elephant.index.Fuzziness", [{
			no: 1,
			name: "edits",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "auto",
			kind: "message",
			T: () => FuzzinessAuto
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.edits = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.edits = reader.int64().toBigInt();
					break;
				case 2:
					message.auto = FuzzinessAuto.internalBinaryRead(reader, reader.uint32(), options, message.auto);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.edits !== 0n) writer.tag(1, WireType.Varint).int64(message.edits);
		if (message.auto) FuzzinessAuto.internalBinaryWrite(message.auto, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.Fuzziness
*/
const Fuzziness = new Fuzziness$Type();
var FuzzinessAuto$Type = class extends MessageType {
	constructor() {
		super("elephant.index.FuzzinessAuto", [{
			no: 1,
			name: "low",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "high",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.low = 0n;
		message.high = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.low = reader.int64().toBigInt();
					break;
				case 2:
					message.high = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.low !== 0n) writer.tag(1, WireType.Varint).int64(message.low);
		if (message.high !== 0n) writer.tag(2, WireType.Varint).int64(message.high);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.FuzzinessAuto
*/
const FuzzinessAuto = new FuzzinessAuto$Type();
var MatchPhraseQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MatchPhraseQueryV1", [{
			no: 1,
			name: "field",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "value",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.value = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.value = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		if (message.value !== "") writer.tag(2, WireType.LengthDelimited).string(message.value);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MatchPhraseQueryV1
*/
const MatchPhraseQueryV1 = new MatchPhraseQueryV1$Type();
var PrefixQueryV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.PrefixQueryV1", [
			{
				no: 1,
				name: "field",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "value",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "case_insensitive",
				kind: "scalar",
				T: 8
			},
			{
				no: 4,
				name: "boost",
				kind: "scalar",
				T: 1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.value = "";
		message.caseInsensitive = false;
		message.boost = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.value = reader.string();
					break;
				case 3:
					message.caseInsensitive = reader.bool();
					break;
				case 4:
					message.boost = reader.double();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		if (message.value !== "") writer.tag(2, WireType.LengthDelimited).string(message.value);
		if (message.caseInsensitive !== false) writer.tag(3, WireType.Varint).bool(message.caseInsensitive);
		if (message.boost !== 0) writer.tag(4, WireType.Bit64).double(message.boost);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.PrefixQueryV1
*/
const PrefixQueryV1 = new PrefixQueryV1$Type();
var SortingV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.SortingV1", [{
			no: 1,
			name: "field",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "desc",
			kind: "scalar",
			T: 8
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.field = "";
		message.desc = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.field = reader.string();
					break;
				case 2:
					message.desc = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.field !== "") writer.tag(1, WireType.LengthDelimited).string(message.field);
		if (message.desc !== false) writer.tag(2, WireType.Varint).bool(message.desc);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.SortingV1
*/
const SortingV1 = new SortingV1$Type();
var QueryResponseV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.QueryResponseV1", [
			{
				no: 1,
				name: "took",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 2,
				name: "timed_out",
				kind: "scalar",
				T: 8
			},
			{
				no: 3,
				name: "shards",
				kind: "message",
				T: () => ShardsV1
			},
			{
				no: 4,
				name: "hits",
				kind: "message",
				T: () => HitsV1
			},
			{
				no: 5,
				name: "subscription",
				kind: "message",
				T: () => SubscriptionReference
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.took = 0n;
		message.timedOut = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.took = reader.int64().toBigInt();
					break;
				case 2:
					message.timedOut = reader.bool();
					break;
				case 3:
					message.shards = ShardsV1.internalBinaryRead(reader, reader.uint32(), options, message.shards);
					break;
				case 4:
					message.hits = HitsV1.internalBinaryRead(reader, reader.uint32(), options, message.hits);
					break;
				case 5:
					message.subscription = SubscriptionReference.internalBinaryRead(reader, reader.uint32(), options, message.subscription);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.took !== 0n) writer.tag(1, WireType.Varint).int64(message.took);
		if (message.timedOut !== false) writer.tag(2, WireType.Varint).bool(message.timedOut);
		if (message.shards) ShardsV1.internalBinaryWrite(message.shards, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		if (message.hits) HitsV1.internalBinaryWrite(message.hits, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		if (message.subscription) SubscriptionReference.internalBinaryWrite(message.subscription, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.QueryResponseV1
*/
const QueryResponseV1 = new QueryResponseV1$Type();
var ShardsV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.ShardsV1", [
			{
				no: 1,
				name: "total",
				kind: "scalar",
				T: 5
			},
			{
				no: 2,
				name: "successful",
				kind: "scalar",
				T: 5
			},
			{
				no: 3,
				name: "skipped",
				kind: "scalar",
				T: 5
			},
			{
				no: 4,
				name: "failed",
				kind: "scalar",
				T: 5
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.total = 0;
		message.successful = 0;
		message.skipped = 0;
		message.failed = 0;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.total = reader.int32();
					break;
				case 2:
					message.successful = reader.int32();
					break;
				case 3:
					message.skipped = reader.int32();
					break;
				case 4:
					message.failed = reader.int32();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.total !== 0) writer.tag(1, WireType.Varint).int32(message.total);
		if (message.successful !== 0) writer.tag(2, WireType.Varint).int32(message.successful);
		if (message.skipped !== 0) writer.tag(3, WireType.Varint).int32(message.skipped);
		if (message.failed !== 0) writer.tag(4, WireType.Varint).int32(message.failed);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.ShardsV1
*/
const ShardsV1 = new ShardsV1$Type();
var HitsV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.HitsV1", [
			{
				no: 1,
				name: "total",
				kind: "message",
				T: () => HitsTotalV1
			},
			{
				no: 2,
				name: "max_score",
				kind: "scalar",
				T: 2
			},
			{
				no: 3,
				name: "hits",
				kind: "message",
				repeat: 2,
				T: () => HitV1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.maxScore = 0;
		message.hits = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.total = HitsTotalV1.internalBinaryRead(reader, reader.uint32(), options, message.total);
					break;
				case 2:
					message.maxScore = reader.float();
					break;
				case 3:
					message.hits.push(HitV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.total) HitsTotalV1.internalBinaryWrite(message.total, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.maxScore !== 0) writer.tag(2, WireType.Bit32).float(message.maxScore);
		for (let i = 0; i < message.hits.length; i++) HitV1.internalBinaryWrite(message.hits[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.HitsV1
*/
const HitsV1 = new HitsV1$Type();
var HitsTotalV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.HitsTotalV1", [{
			no: 1,
			name: "value",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "relation",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.value = 0n;
		message.relation = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.value = reader.int64().toBigInt();
					break;
				case 2:
					message.relation = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.value !== 0n) writer.tag(1, WireType.Varint).int64(message.value);
		if (message.relation !== "") writer.tag(2, WireType.LengthDelimited).string(message.relation);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.HitsTotalV1
*/
const HitsTotalV1 = new HitsTotalV1$Type();
var HitV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.HitV1", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "score",
				kind: "scalar",
				T: 2
			},
			{
				no: 3,
				name: "fields",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => FieldValuesV1
				}
			},
			{
				no: 4,
				name: "source",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => FieldValuesV1
				}
			},
			{
				no: 5,
				name: "sort",
				kind: "scalar",
				repeat: 2,
				T: 9
			},
			{
				no: 6,
				name: "document",
				kind: "message",
				T: () => Document
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = "";
		message.score = 0;
		message.fields = {};
		message.source = {};
		message.sort = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.string();
					break;
				case 2:
					message.score = reader.float();
					break;
				case 3:
					this.binaryReadMap3(message.fields, reader, options);
					break;
				case 4:
					this.binaryReadMap4(message.source, reader, options);
					break;
				case 5:
					message.sort.push(reader.string());
					break;
				case 6:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap3(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = FieldValuesV1.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.index.HitV1.fields");
			}
		}
		map[key ?? ""] = val ?? FieldValuesV1.create();
	}
	binaryReadMap4(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = FieldValuesV1.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.index.HitV1.source");
			}
		}
		map[key ?? ""] = val ?? FieldValuesV1.create();
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== "") writer.tag(1, WireType.LengthDelimited).string(message.id);
		if (message.score !== 0) writer.tag(2, WireType.Bit32).float(message.score);
		for (let k of globalThis.Object.keys(message.fields)) {
			writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			FieldValuesV1.internalBinaryWrite(message.fields[k], writer, options);
			writer.join().join();
		}
		for (let k of globalThis.Object.keys(message.source)) {
			writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			FieldValuesV1.internalBinaryWrite(message.source[k], writer, options);
			writer.join().join();
		}
		for (let i = 0; i < message.sort.length; i++) writer.tag(5, WireType.LengthDelimited).string(message.sort[i]);
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.HitV1
*/
const HitV1 = new HitV1$Type();
var FieldValuesV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.FieldValuesV1", [{
			no: 1,
			name: "values",
			kind: "scalar",
			repeat: 2,
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.values = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.values.push(reader.string());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.values.length; i++) writer.tag(1, WireType.LengthDelimited).string(message.values[i]);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.FieldValuesV1
*/
const FieldValuesV1 = new FieldValuesV1$Type();
var GetFlatDocumentRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.GetFlatDocumentRequest", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "version",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "status",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "stored",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.version = 0n;
		message.status = "";
		message.stored = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.version = reader.int64().toBigInt();
					break;
				case 3:
					message.status = reader.string();
					break;
				case 4:
					message.stored = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.version !== 0n) writer.tag(2, WireType.Varint).int64(message.version);
		if (message.status !== "") writer.tag(3, WireType.LengthDelimited).string(message.status);
		if (message.stored !== false) writer.tag(4, WireType.Varint).bool(message.stored);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.GetFlatDocumentRequest
*/
const GetFlatDocumentRequest = new GetFlatDocumentRequest$Type();
var GetFlatDocumentResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.GetFlatDocumentResponse", [{
			no: 1,
			name: "fields",
			kind: "map",
			K: 9,
			V: {
				kind: "message",
				T: () => FieldValuesV1
			}
		}, {
			no: 2,
			name: "document",
			kind: "message",
			T: () => Document
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.fields = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					this.binaryReadMap1(message.fields, reader, options);
					break;
				case 2:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap1(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = FieldValuesV1.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.index.GetFlatDocumentResponse.fields");
			}
		}
		map[key ?? ""] = val ?? FieldValuesV1.create();
	}
	internalBinaryWrite(message, writer, options) {
		for (let k of globalThis.Object.keys(message.fields)) {
			writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			FieldValuesV1.internalBinaryWrite(message.fields[k], writer, options);
			writer.join().join();
		}
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.GetFlatDocumentResponse
*/
const GetFlatDocumentResponse = new GetFlatDocumentResponse$Type();
var GetMappingsRequestV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.GetMappingsRequestV1", [{
			no: 1,
			name: "document_type",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.documentType = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.documentType = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.documentType !== "") writer.tag(1, WireType.LengthDelimited).string(message.documentType);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.GetMappingsRequestV1
*/
const GetMappingsRequestV1 = new GetMappingsRequestV1$Type();
var GetMappingsResponseV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.GetMappingsResponseV1", [{
			no: 1,
			name: "properties",
			kind: "message",
			repeat: 2,
			T: () => MappingPropertyV1
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.properties = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.properties.push(MappingPropertyV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.properties.length; i++) MappingPropertyV1.internalBinaryWrite(message.properties[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.GetMappingsResponseV1
*/
const GetMappingsResponseV1 = new GetMappingsResponseV1$Type();
var MappingPropertyV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MappingPropertyV1", [
			{
				no: 1,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "path",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "fields",
				kind: "message",
				repeat: 2,
				T: () => MappingFieldV1
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.type = "";
		message.path = "";
		message.fields = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.path = reader.string();
					break;
				case 4:
					message.fields.push(MappingFieldV1.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.path !== "") writer.tag(3, WireType.LengthDelimited).string(message.path);
		for (let i = 0; i < message.fields.length; i++) MappingFieldV1.internalBinaryWrite(message.fields[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MappingPropertyV1
*/
const MappingPropertyV1 = new MappingPropertyV1$Type();
var MappingFieldV1$Type = class extends MessageType {
	constructor() {
		super("elephant.index.MappingFieldV1", [{
			no: 1,
			name: "name",
			kind: "scalar",
			T: 9
		}, {
			no: 2,
			name: "type",
			kind: "scalar",
			T: 9
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.name = "";
		message.type = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.name = reader.string();
					break;
				case 2:
					message.type = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.name !== "") writer.tag(1, WireType.LengthDelimited).string(message.name);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.MappingFieldV1
*/
const MappingFieldV1 = new MappingFieldV1$Type();
var PollSubscriptionRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.PollSubscriptionRequest", [
			{
				no: 1,
				name: "subscriptions",
				kind: "message",
				repeat: 2,
				T: () => SubscriptionReference
			},
			{
				no: 2,
				name: "max_wait_ms",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 3,
				name: "batch_delay_ms",
				kind: "scalar",
				T: 3,
				L: 0
			},
			{
				no: 4,
				name: "notify_only",
				kind: "scalar",
				T: 8
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.subscriptions = [];
		message.maxWaitMs = 0n;
		message.batchDelayMs = 0n;
		message.notifyOnly = false;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.subscriptions.push(SubscriptionReference.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					message.maxWaitMs = reader.int64().toBigInt();
					break;
				case 3:
					message.batchDelayMs = reader.int64().toBigInt();
					break;
				case 4:
					message.notifyOnly = reader.bool();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.subscriptions.length; i++) SubscriptionReference.internalBinaryWrite(message.subscriptions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.maxWaitMs !== 0n) writer.tag(2, WireType.Varint).int64(message.maxWaitMs);
		if (message.batchDelayMs !== 0n) writer.tag(3, WireType.Varint).int64(message.batchDelayMs);
		if (message.notifyOnly !== false) writer.tag(4, WireType.Varint).bool(message.notifyOnly);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.PollSubscriptionRequest
*/
const PollSubscriptionRequest = new PollSubscriptionRequest$Type();
var SubscriptionReference$Type = class extends MessageType {
	constructor() {
		super("elephant.index.SubscriptionReference", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}, {
			no: 2,
			name: "cursor",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		message.cursor = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				case 2:
					message.cursor = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		if (message.cursor !== 0n) writer.tag(2, WireType.Varint).int64(message.cursor);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.SubscriptionReference
*/
const SubscriptionReference = new SubscriptionReference$Type();
var PollSubscriptionResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.PollSubscriptionResponse", [{
			no: 1,
			name: "result",
			kind: "message",
			repeat: 2,
			T: () => SubscriptionPollResult
		}, {
			no: 2,
			name: "unknown_subscriptions",
			kind: "scalar",
			repeat: 1,
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.result = [];
		message.unknownSubscriptions = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.result.push(SubscriptionPollResult.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 2:
					if (wireType === WireType.LengthDelimited) for (let e = reader.int32() + reader.pos; reader.pos < e;) message.unknownSubscriptions.push(reader.int64().toBigInt());
					else message.unknownSubscriptions.push(reader.int64().toBigInt());
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		for (let i = 0; i < message.result.length; i++) SubscriptionPollResult.internalBinaryWrite(message.result[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		if (message.unknownSubscriptions.length) {
			writer.tag(2, WireType.LengthDelimited).fork();
			for (let i = 0; i < message.unknownSubscriptions.length; i++) writer.int64(message.unknownSubscriptions[i]);
			writer.join();
		}
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.PollSubscriptionResponse
*/
const PollSubscriptionResponse = new PollSubscriptionResponse$Type();
var SubscriptionPollResult$Type = class extends MessageType {
	constructor() {
		super("elephant.index.SubscriptionPollResult", [{
			no: 1,
			name: "subscription",
			kind: "message",
			T: () => SubscriptionReference
		}, {
			no: 2,
			name: "items",
			kind: "message",
			repeat: 2,
			T: () => SubscriptionItem
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.items = [];
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.subscription = SubscriptionReference.internalBinaryRead(reader, reader.uint32(), options, message.subscription);
					break;
				case 2:
					message.items.push(SubscriptionItem.internalBinaryRead(reader, reader.uint32(), options));
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.subscription) SubscriptionReference.internalBinaryWrite(message.subscription, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.items.length; i++) SubscriptionItem.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.SubscriptionPollResult
*/
const SubscriptionPollResult = new SubscriptionPollResult$Type();
var SubscriptionItem$Type = class extends MessageType {
	constructor() {
		super("elephant.index.SubscriptionItem", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "match",
				kind: "scalar",
				T: 8
			},
			{
				no: 3,
				name: "fields",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => FieldValuesV1
				}
			},
			{
				no: 4,
				name: "source",
				kind: "map",
				K: 9,
				V: {
					kind: "message",
					T: () => FieldValuesV1
				}
			},
			{
				no: 5,
				name: "document",
				kind: "message",
				T: () => Document
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = "";
		message.match = false;
		message.fields = {};
		message.source = {};
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.string();
					break;
				case 2:
					message.match = reader.bool();
					break;
				case 3:
					this.binaryReadMap3(message.fields, reader, options);
					break;
				case 4:
					this.binaryReadMap4(message.source, reader, options);
					break;
				case 5:
					message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap3(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = FieldValuesV1.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.index.SubscriptionItem.fields");
			}
		}
		map[key ?? ""] = val ?? FieldValuesV1.create();
	}
	binaryReadMap4(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = FieldValuesV1.internalBinaryRead(reader, reader.uint32(), options);
					break;
				default: throw new globalThis.Error("unknown map entry field for elephant.index.SubscriptionItem.source");
			}
		}
		map[key ?? ""] = val ?? FieldValuesV1.create();
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== "") writer.tag(1, WireType.LengthDelimited).string(message.id);
		if (message.match !== false) writer.tag(2, WireType.Varint).bool(message.match);
		for (let k of globalThis.Object.keys(message.fields)) {
			writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			FieldValuesV1.internalBinaryWrite(message.fields[k], writer, options);
			writer.join().join();
		}
		for (let k of globalThis.Object.keys(message.source)) {
			writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
			writer.tag(2, WireType.LengthDelimited).fork();
			FieldValuesV1.internalBinaryWrite(message.source[k], writer, options);
			writer.join().join();
		}
		if (message.document) Document.internalBinaryWrite(message.document, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.SubscriptionItem
*/
const SubscriptionItem = new SubscriptionItem$Type();
var EndSubscriptionRequest$Type = class extends MessageType {
	constructor() {
		super("elephant.index.EndSubscriptionRequest", [{
			no: 1,
			name: "id",
			kind: "scalar",
			T: 3,
			L: 0
		}]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = 0n;
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.int64().toBigInt();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== 0n) writer.tag(1, WireType.Varint).int64(message.id);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.EndSubscriptionRequest
*/
const EndSubscriptionRequest = new EndSubscriptionRequest$Type();
var EndSubscriptionResponse$Type = class extends MessageType {
	constructor() {
		super("elephant.index.EndSubscriptionResponse", []);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message elephant.index.EndSubscriptionResponse
*/
const EndSubscriptionResponse = new EndSubscriptionResponse$Type();
/**
* @generated ServiceType for protobuf service elephant.index.Management
*/
const Management = new ServiceType("elephant.index.Management", [
	{
		name: "RegisterCluster",
		options: {},
		I: RegisterClusterRequest,
		O: RegisterClusterResponse
	},
	{
		name: "ListClusters",
		options: {},
		I: ListClustersRequest,
		O: ListClustersResponse
	},
	{
		name: "DeleteCluster",
		options: {},
		I: DeleteClusterRequest,
		O: DeleteClusterResponse
	},
	{
		name: "DeleteIndexSet",
		options: {},
		I: DeleteIndexSetRequest,
		O: DeleteIndexSetResponse
	},
	{
		name: "Reindex",
		options: {},
		I: ReindexRequest,
		O: ReindexResponse
	},
	{
		name: "PartialReindex",
		options: {},
		I: PartialReindexRequest,
		O: PartialReindexResponse
	},
	{
		name: "ListIndexSets",
		options: {},
		I: ListIndexSetsRequest,
		O: ListIndexSetsResponse
	},
	{
		name: "SetIndexSetStatus",
		options: {},
		I: SetIndexSetStatusRequest,
		O: SetIndexSetStatusResponse
	}
]);
/**
* @generated ServiceType for protobuf service elephant.index.SearchV1
*/
const SearchV1 = new ServiceType("elephant.index.SearchV1", [
	{
		name: "Query",
		options: {},
		I: QueryRequestV1,
		O: QueryResponseV1
	},
	{
		name: "MultiSearch",
		options: {},
		I: MultiSearchRequest,
		O: MultiSearchResponse
	},
	{
		name: "GetFlatDocument",
		options: {},
		I: GetFlatDocumentRequest,
		O: GetFlatDocumentResponse
	},
	{
		name: "GetMappings",
		options: {},
		I: GetMappingsRequestV1,
		O: GetMappingsResponseV1
	},
	{
		name: "PollSubscription",
		options: {},
		I: PollSubscriptionRequest,
		O: PollSubscriptionResponse
	},
	{
		name: "EndSubscription",
		options: {},
		I: EndSubscriptionRequest,
		O: EndSubscriptionResponse
	}
]);
//#endregion
//#region src/index/service.client.ts
/**
* @generated from protobuf service elephant.index.Management
*/
var ManagementClient = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = Management.typeName;
		this.methods = Management.methods;
		this.options = Management.options;
	}
	/**
	* RegisterCluster for use with index sets.
	*
	* @generated from protobuf rpc: RegisterCluster
	*/
	registerCluster(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListClusters returns a list of clusters together with information about the
	* number of index sets they contain.
	*
	* @generated from protobuf rpc: ListClusters
	*/
	listClusters(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* DeleteCluster deletes a registered cluster. A cluster cannot be deleted as
	* long as it has associated index sets.
	*
	* @generated from protobuf rpc: DeleteCluster
	*/
	deleteCluster(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* DeleteIndexSet deletes an index set. The set cannot be active or enabled.
	*
	* @generated from protobuf rpc: DeleteIndexSet
	*/
	deleteIndexSet(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* Reindex set creates a new index set in the specified cluster and starts
	* indexing documents to it.
	*
	* @generated from protobuf rpc: Reindex
	*/
	reindex(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* PartialReindex restarts an existing index set from a given point in the
	* repository eventlog.
	*
	* @generated from protobuf rpc: PartialReindex
	*/
	partialReindex(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* ListIndexSets lists the available index set, with optional filtering.
	*
	* @generated from protobuf rpc: ListIndexSets
	*/
	listIndexSets(input, options) {
		const method = this.methods[6], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* SetIndexSetStatus is used to change the status of an index set.
	*
	* @generated from protobuf rpc: SetIndexSetStatus
	*/
	setIndexSetStatus(input, options) {
		const method = this.methods[7], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
/**
* @generated from protobuf service elephant.index.SearchV1
*/
var SearchV1Client = class {
	constructor(_transport) {
		this._transport = _transport;
		this.typeName = SearchV1.typeName;
		this.methods = SearchV1.methods;
		this.options = SearchV1.options;
	}
	/**
	* @generated from protobuf rpc: Query
	*/
	query(input, options) {
		const method = this.methods[0], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: MultiSearch
	*/
	multiSearch(input, options) {
		const method = this.methods[1], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* GetFlatDocument fetches a document directly from the repository and returns
	* it in the flattened representation used for indexing. This bypasses
	* OpenSearch, so the result always reflects the current state of the
	* repository without the eventual consistency of the index.
	*
	* @generated from protobuf rpc: GetFlatDocument
	*/
	getFlatDocument(input, options) {
		const method = this.methods[2], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: GetMappings
	*/
	getMappings(input, options) {
		const method = this.methods[3], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: PollSubscription
	*/
	pollSubscription(input, options) {
		const method = this.methods[4], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
	/**
	* @generated from protobuf rpc: EndSubscription
	*/
	endSubscription(input, options) {
		const method = this.methods[5], opt = this._transport.mergeOptions(options);
		return stackIntercept("unary", this._transport, method, opt, input);
	}
};
//#endregion
export { BoolQueryV1, Cluster, ClusterAuth, DeleteClusterRequest, DeleteClusterResponse, DeleteIndexSetRequest, DeleteIndexSetResponse, EnabledFilter, EndSubscriptionRequest, EndSubscriptionResponse, FieldValuesV1, Fuzziness, FuzzinessAuto, GetFlatDocumentRequest, GetFlatDocumentResponse, GetMappingsRequestV1, GetMappingsResponseV1, HitV1, HitsTotalV1, HitsV1, IndexSet, ListClustersRequest, ListClustersResponse, ListIndexSetsRequest, ListIndexSetsResponse, Management, ManagementClient, MappingFieldV1, MappingPropertyV1, MatchAllQueryV1, MatchPhraseQueryV1, MatchQueryV1, MultiMatchQueryV1, MultiSearchRequest, MultiSearchResponse, PartialReindexRequest, PartialReindexResponse, PollSubscriptionRequest, PollSubscriptionResponse, PrefixQueryV1, QueryRequestV1, QueryResponseV1, QueryV1, RangeQueryV1, RegisterClusterAuth, RegisterClusterRequest, RegisterClusterResponse, ReindexRequest, ReindexResponse, SearchV1, SearchV1Client, SetIndexSetStatusRequest, SetIndexSetStatusResponse, ShardsV1, SortingV1, SubscriptionItem, SubscriptionPollResult, SubscriptionReference, TermQueryV1, TermsQueryV1 };
